/* global google */
import React, { Component, useState, useEffect } from 'react';
import {
  withGoogleMap,
  withScriptjs,
  Marker,
  GroundOverlay,
  GoogleMap,
  OverlayView
} from 'react-google-maps';
import { MarkerWithLabel } from 'react-google-maps/lib/components/addons/MarkerWithLabel';

export default class Map extends Component {
  constructor(props) {
    super(props);
    this.isUpdateRefCalled = false;
    this.mrkRef = [];
    this.mouseLastEvent = null;

    this.GoogleMapWithHooks = withScriptjs(withGoogleMap(
      props => {
        const {
          onMapClick,
          onMarkerClick,
          markers,
          center,
          image,
          bounds,
          defaultZoom,
          draggableMarkers,
          onMarkerPositionChanged,
          groundOverlayOpacity,
          draggableGroundOverlay,
          onGroundOverlayDragged,
        } = props;
        const [currentPosition, setCurrentPosition] = useState({});
        const [draggable,setDraggable] = useState(true);

        useEffect(() => {
          navigator.geolocation.getCurrentPosition(position => {
            if (position) {
              setCurrentPosition({
                lat: position.coords.latitude,
                lng: position.coords.longitude
              })
            }
          }, () => { }, {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 1000
          })
        }, []);

        const putCurrentLocation = () => {
          if (currentPosition) {
            return (
              <Marker
                icon="https://www.robotwoods.com/dev/misc/bluecircle.png"
                key={`mrkCurrentLocation`}
                position={currentPosition}
              />)
          }
        }

        const putMarkers = () => {

          if (!markers) {
            return;
          }

          const marker = {
            lat: parseFloat(markers.lat),
            lng: parseFloat(markers.lng)
          }
          const labelSize = { width: 40};
          const labelPadding = 1;
      
          if (markers instanceof Array) {
            return markers.map((mrk, i) => (
              mrk.label ? 
              <MarkerWithLabel
                icon={{path:"M -7, -7 a 7,7 0 1,1 14,0 a 7,7 0 1,1 -14,0", 
                      fillColor: mrk.color, fillOpacity:1,strokeColor:'white'}}
                ref={ref => this.mrkRef[i] = ref}
                defaultDraggable={draggableMarkers}
                key={`mrk${i}`}
                position={mrk}
                onClick={e => onMarkerClick(e)}
                onPositionChanged={() => onMarkerPositionChanged ? onMarkerPositionChanged(i) : null}
                labelStyle={{ borderRadius: "30px", textAlign: "center", width:labelSize.width + 'px', backgroundColor: "rgba(255, 255, 255, 0.3)", fontSize: "14px", padding:  labelPadding + "px",color:mrk.color, fontWeight:'bold'}}
                labelAnchor={{ x: (labelSize.width/2 - 25) + labelPadding , y: 0 }}
              >
                <span style={{fontSize:19,opacity:1}}>{mrk.label}</span>
              </MarkerWithLabel>
            :
            <Marker
            ref={ref => this.mrkRef[i] = ref}
            defaultDraggable={draggableMarkers}
            key={`mrk${i}`}
            position={mrk}
            onClick={e => onMarkerClick(e)}
            onPositionChanged={() => onMarkerPositionChanged ? onMarkerPositionChanged(i) : null}
          />
            ));
          }

          return (
            <Marker
              ref={ref => this.mrkRef[0] = ref}
              defaultDraggable={draggableMarkers}
              key="mrk"
              position={marker}
              onClick={e => onMarkerClick(e)}
              onPositionChanged={() => onMarkerPositionChanged ? onMarkerPositionChanged(0) : null}
            />
          );
        };

        const onGroundOverlayMouseDown = (e) => {
          this.mouseLastPos = {x:e.clientX,y:e.clientY};
          setDraggable(false);
        };

        const onGroundOverlayMouseUp = (e) => {
          setDraggable(true);
        };

        const onGroundOverlayMouseMove = (e) => {
          if (!draggable && this.mouseLastPos) {
            const left = this.mouseLastPos.x - e.clientX;
            const top = this.mouseLastPos.y - e.clientY;
            const newBounds = bounds.map((pos) => caculateNewPoint(new google.maps.LatLng(pos[0],pos[1]), left, top));
            this.mouseLastPos = {x:e.clientX,y:e.clientY};;
            onGroundOverlayDragged(newBounds);
          }
        };

        const caculateNewPoint = (pos, left, top) => {
          const posAsPixels = this.overlayRef.getProjection().fromLatLngToDivPixel(pos);
          const newPos = this.overlayRef.getProjection().fromDivPixelToLatLng(new google.maps.Point(posAsPixels.x - left,
            posAsPixels.y - top));

          return newPos;
        };

        const groundOverlay = () => {
          if (!bounds || bounds < 1 || !image || image === "") {
            return;
          }

          const gbounds = new google.maps.LatLngBounds(
            new google.maps.LatLng(bounds ? bounds[1][0] : 0, bounds ? bounds[1][1] : 0),
            new google.maps.LatLng(bounds ? bounds[0][0] : 0, bounds ? bounds[0][1] : 0)
          )
          if (!draggableGroundOverlay) {
            return (
              <GroundOverlay
                ref={ref => this.groundOverlayRef = ref}
                onClick={e => onMapClick(e)}
                defaultBounds={gbounds}
                opacity={groundOverlayOpacity}
                url={image}
              />
            )
          }
          else {
            return (
              <OverlayView mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET} bounds={gbounds} ref={ref => this.overlayRef = ref}
              >
                <div style={{ height: '100%', width: '100%' }}
                  onMouseUp={onGroundOverlayMouseUp}
                  onMouseMove={onGroundOverlayMouseMove}
                  onMouseDown={onGroundOverlayMouseDown}>
                  <img
                    ref={ref => this.groundOverlayRef = ref}
                    style={{opacity:groundOverlayOpacity, height: "100%",width:"100%"}}
                    src={image}
                  />
                </div>
              </OverlayView>
            );
          }
        }

        const mapLoaded = () => {
          console.log(image)
        }

        return (
          <GoogleMap
            ref={ref => this.mapRef = ref}
            onGoogleApiLoaded={mapLoaded}
            defaultZoom={defaultZoom}
            defaultCenter={center}
            onClick={e => onMapClick(e)}
            onBoundsChanged={props.onBoundsChanged}
            options={{ draggable: draggable }}
          >
            {groundOverlay()}
            {putMarkers()}
            {putCurrentLocation()}
          </GoogleMap>
        );
      },
    ));
  }

  getMrkPosition = (order) => {
    return this.mrkRef[order].getPosition();
  };

  getBounds = () => {
    return this.mapRef.getBounds();
  }

  render() {

    return <span><this.GoogleMapWithHooks {...this.props} /></span>
  }
}